<header>
  <div *ngIf="image" class="logo" [style.background-image]="'url(' + image + ')'">
    <img [src]="image" alt="" />
  </div>
  <h2>{{providerName}} wants access to your Investment Profile</h2>
  <h3><span inlineSVG="/assets/icons/portfolio.svg"></span> {{clientName}}</h3>
</header>

<section class="permissions">
  <p>
    This will <strong>allow</strong> {{providerName}} and its service providers to:
  </p>
  <ul>
    <li>
      <span inlineSVG="/assets/icons/edit.svg"></span>
      <span>
        Edit your investment profile details, including personal information identifiers, contact information, and
        financial/transaction information as identified in our <a class="anchor-svg" href="{{ PRIVACY_POLICY_URL }}"
        target="_blank">Privacy Policy <span inlineSVG="/assets/icons/link-1.svg"></span></a>.
      </span>
    </li>
    <li>
      <span inlineSVG="/assets/icons/user-plus.svg"></span>
      Add and remove team members from your investment profile.
    </li>
    <li>
      <span inlineSVG="/assets/icons/text-plus.svg"></span>
      Add and manage documents linked to your investment profile.
    </li>
  </ul>
</section>

<section class="permissions">
  <p>
    This will <strong>not allow</strong> {{providerName}} and its service providers to:
  </p>
  <ul>
    <li>
      <span inlineSVG="/assets/icons/currency-coin.svg"></span>
      Access information pertaining to your participation in funds or organizations outside of {{clientName}}.
    </li>
    <li>
      <span inlineSVG="/assets/icons/pen.svg"></span>
      Sign documents on your behalf
    </li>
  </ul>
</section>

<section class="details">
  <h4>Understand the risk</h4>
  <p>
    Granting access to your investment profile will allow this organization to update information for this investment
    profile across Flow. Any other funds this account may be associated with will see these updates.
  </p>
  <p>
    You can always manage access from this investment profile’s settings.
  </p>
  <p>
    <a class="anchor-svg" href="https://help.flowinc.com/hc/en-us/articles/6535405846292-Investment-Profile-Access-Overview" target="_blank">Learn more about Investment Profile Access <span inlineSVG="/assets/icons/link-1.svg"></span></a>
  </p>
  <p>
    For additional details on how your information is used, please view our <a class="anchor-svg" href="{{ PRIVACY_POLICY_URL }}" target="_blank">privacy policy<span inlineSVG="/assets/icons/link-1.svg"></span></a>.
  </p>
</section>

<section class="actions">
  <button type="button" (click)="denyProvider()" [disabled]="submitting">Deny</button>
  <button type="submit" (click)="allowProvider()" [disabled]="submitting">Allow</button>
</section>
